import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { PreparationState } from '@/store/lessons/preparation/types';
import mutations from './mutations';
import actions from './actions';
import getters from './getters'

const Preparation: Module<PreparationState, RootState> = {
  state: {
    preparation: null,
  },
  mutations,
  actions,
  getters,
};

export default Preparation;
